import { useEffect } from 'react';
import { useMatch, useNavigate, Outlet } from 'react-router-dom';
import { useAppSelector, useAppDispatch } from '@store';
import { PermissionDenied, PermissionEnum } from '@ui/src';
import { clearAccountingManagmentState } from './store/slice';

import ROUTES from '../../routes';

import cn from './styles.module.css';

const AccountingManagment = () => {
  const match = useMatch(ROUTES.REPORTS_ACCOUNTING_MANAGMENT);

  const { activePermissions } = useAppSelector(
    (state) => state.reportsDictionaries,
  );

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      activePermissions?.includes(
        PermissionEnum.REPORTS_ACCOUNTING_JOBS_LITS,
      ) &&
      match
    ) {
      navigate(ROUTES.REPORTS_ACCOUNTING_MANAGMENT_LIST);
    }

    return () => {
      dispatch(clearAccountingManagmentState());
    };
  }, [activePermissions, match]);

  useEffect(() => {
    let title = 'Accounting Management';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  let content;

  if (
    !activePermissions?.includes(PermissionEnum.REPORTS_ACCOUNTING_JOBS_LITS)
  ) {
    content = <PermissionDenied />;
  } else {
    content = <Outlet />;
  }

  return (
    <div className={cn.accountingManagment}>
      <div className={cn.accountManagmentTitle}>Accounting Management</div>
      {content}
    </div>
  );
};

export default AccountingManagment;
